/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 7/27/15.
 */
'use strict';
angular.module('prism-ui.components').directive('prismTimePicker', function(twoDigitNumFilter) {

	return {
		restrict: 'E',
		controller: function () {},
		template: '<fieldset ng-disabled="timePickerCtrl.componentDisabled">' + '<div uib-timepicker ng-model="timePickerCtrl.timeInput" class="timepicker col-sm-3 time-component-md" mousewheel="false" hour-step="1" ' +
		'minute-step="15" show-meridian="true" ng-change="timePickerCtrl.timeChanged()" template-url="components/visual/timepicker/prism-timepicker-template.html"> </div></fieldset>',
		require: ['ngModel', 'prismTimePicker'],
		scope: {componentDisabled: '=ngDisabled'},
		bindToController: {componentDisabled: '=ngDisabled'},
		controllerAs: 'timePickerCtrl',
		link: function (scope, element, attrs, ctrls) {
			var ngModelCtrl = ctrls[0];
			var timePickerCtrl = ctrls[1];

			/**
			 * Reset displayed (scope) values based on $viewValue
			 */
			ngModelCtrl.$render = function() {
				timePickerCtrl.timeInput = ngModelCtrl.$viewValue.timeInput;
			};

			var verifyModelFormat = function (val) {
				return /[0-9][0-9]:[0-9][0-9]/.test(val);
			};

			/**
			 * Called whenever the model is changed programatically and also on initial loading
			 */
			ngModelCtrl.$formatters.push(function (modelValue) {
				var time = new Date();
				var timeString = modelValue && verifyModelFormat(modelValue) ? modelValue : '00:00';
				var timeParts = timeString.split(':');
				time.setHours(timeParts[0]);
				time.setMinutes(timeParts[1]);

				return {timeInput: time};
			});

			/**
			 * Called when the view value is set manually
			 *
			 * @return The updated model which is then assigned to $modelValue
			 */
			ngModelCtrl.$parsers.push(function(viewValue) {
				return twoDigitNumFilter(viewValue.timeInput.getHours()) + ':' + twoDigitNumFilter(viewValue.timeInput.getMinutes());
			});

			timePickerCtrl.timeChanged = function () {
				var newDate = new Date();
				newDate.setHours(timePickerCtrl.timeInput.getHours());
				newDate.setMinutes(timePickerCtrl.timeInput.getMinutes());
				ngModelCtrl.$setViewValue({timeInput: newDate});
			};
		}
	};
});
